import { STORE_ID, TYPES } from "./types";
import store from "../../index";

function dispatch(data) {
    data = { ...data, storeId: STORE_ID }
    store.dispatch(data);
}

export function setPermitions(value) {
    dispatch({
        type: TYPES.SET_PERMITIONS,
        value
    })
}

export function item(value) {
    dispatch({
        type: TYPES.CENTRO_CUSTO,
        value
    });
}

export function copy(value) {
    dispatch({
        type: TYPES.CENTRO_CUSTO_COPY,
        value
    });
}

export function getItems(value) {
    dispatch({
        type: TYPES.CENTROS_CUSTO,
        value
    });
}

export function headcount(value) {
    dispatch({
        type: TYPES.HEADCOUNT,
        value
    });
}

export function setHeadcount(field, value) {
    dispatch({
        type: TYPES.SET_HEADCOUNT,
        field,
        value
    });
}

export function cleanInvalid(field) {
    dispatch({
        type: TYPES.CLEAN_INVALID_CENTRO_CUSTO,
        field
    });
}

export function cleanRegister() {
    dispatch({
        type: TYPES.CLEAN_REGISTER
    })
}

export function cleanHeadcountOrcado() {
    dispatch({
        type: TYPES.CLEAN_HEADCOUNT
    })
}

export function setActiveTab(value) {
    dispatch({
        type: TYPES.SET_ACTIVE_TAB,
        value
    })
}

export function setSeeRegister(value) {
    dispatch({
        type: TYPES.SET_SEE,
        value
    })
}
